import React from "react";
import { Link } from "react-router";
import HeaderSection from "../../component/HeaderSection";
import FooterSection from "../../component/FooterSection";
import CopyrightSection from "../../component/CopyrightSection";
import SlideBar from "../../component/SlideBar";
import "swiper/css";
import ServiceSliderSection from "../../component/ServiceSliderSection";
import ItumpMobile from "../../component/ItumpMobileSection";
import FAQSection from "../../component/FAQSection";

const Service = () => {
  const faqs = [
    {
      id: "one",
      question: "What is Beneficial Ownership Information (BOI)?",
      answer:
        "BOI is information about the real people who own or control a company. It's like knowing who's really in charge, even if they're not the ones running the day-to-day business.",
    },
    {
      id: "two",
      question: "Who is considered a beneficial owner?",
      answer:
        "Generally, a beneficial owner is someone who owns at least 25% of a company or has significant control over it. Think of it as the person who ultimately benefits from the company's success.",
    },
    {
      id: "three",
      question: "When do I need to file a BOI report?",
      answer:
        "Most companies formed in the U.S. or registered to do business there need to file a BOI report. There are a few exceptions, so it's best to check the rules to be sure.",
    },
    {
      id: "four",
      question: "How does Itump help with BOI reporting?",
      answer:
        "Itump can help you understand the rules, track deadlines, and keep your information organized. It's like having a helpful guide to make the process easier.",
    },
    {
      id: "five",
      question: "When is the deadline for reporting BOI?",
      answer:
        "The deadline for most companies is March 21, 2025. However, it's always a good idea to check for any updates or changes to the deadline.",
    },
    {
      id: "six",
      question: "Can I update my BOI after submitting it?",
      answer:
        "Yes, you can update your BOI if anything changes. It's important to keep your information current and accurate.",
    },
    {
      id: "seven",
      question: "How is my BOI protected?",
      answer:
        "FinCEN has strict security measures in place to protect your information. It's confidential and only accessible to authorized people.",
    },
    {
      id: "eight",
      question: "Do all companies need to report BOI?",
      answer:
        "No, not all companies need to report BOI. There are some exceptions, so it's best to check the rules to see if your company is required to file.",
    },
    {
      id: "nine",
      question: "How do I submit my BOI?",
      answer:
        "You can submit your BOI online through FinCEN's website. They have a secure system for submitting your information electronically.",
    },
  ];

  return (
    <>
      <HeaderSection />
      <SlideBar />

      <section className="hero-section-2 service-hero p-t-200 p-t-xl-160 p-t-lg-120 p-t-md-100 p-t-xs-60 p-b-240 p-b-xl-200 p-b-lg-160 p-b-md-120 p-b-xs-60">
        <div className="container">
          <div className="row">
            <div className="col-md-7 m-b-xs-60">
              <div className="hero-content service-hero-content position-relative">
                <p
                  className="hero-sub-1"
                  data-aos="fade-up"
                  data-aos-delay="50"
                >
                  FINCEN’S BOI
                </p>
                <h2
                  className="hero-title"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  Beneficial Ownership Information Reporting
                </h2>
                <p className="hero-sub" data-aos="fade-up" data-aos-delay="150">
                  Get your Ownership Reporting done with the United States
                  reporting agency seamlessly
                </p>
              </div>
              <div
                className="hero-btn-wrap hero-2-btn-wrap"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <Link to="https://boi.itump.com/login" className="theme-btn">
                  Get Started <i className="fa fa-arrow-right"></i>
                </Link>
              </div>
            </div>
            <div className="col-md-5">
              <div
                className="hero-thumb"
                data-aos="zoom-in"
                data-aos-delay="250"
              >
                <img src="assets/img/thumb/thumb-31.png" alt="thumb" />
              </div>
            </div>
          </div>
        </div>
        <div className="s-hero-shape-1">
          <img src="assets/img/shape/shape-4.png" alt="shape" />
        </div>
        <div className="s-hero-shape-2">
          <img src="assets/img/shape/shape-5.png" alt="shape" />
        </div>
      </section>

      <section className="service-card-section p-b-300 p-b-xl-260 p-b-lg-200 p-b-md-160 p-b-xs-120 position-relative">
        <div className="container">
          <div className="row gy-4 gx-3 gx-lg-4">
            <div className="col-md-6">
              <div className="service-card h-100">
                <div className="service-card-title">
                  <h3 data-aos="fade-up" data-aos-delay="50">
                    Requirements
                  </h3>
                </div>
                <div
                  className="service-card-thumb m-b-80 m-b-md-50 m-b-xs-50"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  <img src="assets/img/thumb/thumb-32.png" alt="thumb" />
                </div>
                <div
                  className="service-card-content m-b-30"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <p className="service-title">Who Needs to Report?</p>
                  <p className="service-body">
                    Any entity registered or operating in the U.S. must report
                    its Beneficial Ownership Information (BOI) to FinCEN,
                    including corporations, LLCs, and similar entities. The
                    report must include details about individuals with
                    significant control or ownership.
                  </p>
                </div>
                <div
                  className="service-card-content"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <p className="service-title">Reporting Deadlines</p>
                  <p className="service-body">
                    Entities must file their initial BOI report within 30 days
                    of registration or formation and update the information
                    annually or whenever there are changes.
                  </p>
                </div>
                <div className="s-service-shape-1">
                  <img src="assets/img/shape/shape-10.png" alt="shape" />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="service-card h-100">
                <div className="service-card-title">
                  <h3 data-aos="fade-up" data-aos-delay="50">
                    What You Get
                  </h3>
                </div>
                <div
                  className="service-card-thumb"
                  data-aos="zoom-in"
                  data-aos-delay="100"
                >
                  <img src="assets/img/thumb/thumb-33.png" alt="thumb" />
                </div>
                <div
                  className="service-card-content m-t-35 m-b-30"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <p className="service-title">
                    Comprehensive Compliance Tools
                  </p>
                  <p className="service-body">
                    Itump provides an intuitive platform to help you identify
                    beneficial owners, prepare necessary documents, and file
                    reports with FinCEN seamlessly. Our tools ensure that you
                    stay compliant with all regulatory requirements.
                  </p>
                </div>
                <div
                  className="service-card-content"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <p className="service-title">Peace of Mind</p>
                  <p className="service-body">
                    With Itump, you can trust that your BOI reporting is
                    accurate and timely. Our system guides you through every
                    step, minimizing errors and reducing the risk of penalties.
                  </p>
                </div>
                <div className="s-service-shape-2">
                  <img src="assets/img/shape/shape-11.png" alt="shape" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src="assets/img/bg/unified-bg-pattern.png"
          alt="bg pattern"
          className="bg-pattern mx-auto w-100 position-absolute start-0 end-0"
        />
      </section>

      <section className="boi-report-section p-b-240 p-b-xl-200 p-b-lg-160 p-b-md-120 p-b-xs-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="common-title-wrap m-b-70 m-b-md-50 m-b-xs-40">
                <h3
                  className="common-title"
                  data-aos="fade-up"
                  data-aos-delay="50"
                >
                  When is a BOI Report needed to be filed?
                </h3>
                <p
                  className="common-title-body"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  Here are some Key Scenarios Requiring a BOI Filing
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="boi-report-list"
                data-aos="fade-up"
                data-aos-delay="150"
              >
                <div className="boi-report-item border-bottom-left">
                  <img
                    src="assets/img/icons/check-square.svg"
                    alt="check-square"
                  />
                  <p>You are a newly formed company</p>
                </div>
                <div className="boi-report-item border-bottom-right">
                  <img
                    src="assets/img/icons/check-square.svg"
                    alt="check-square"
                  />
                  <p>
                    Your existing company needs to complete their first report
                    before the filing deadline
                  </p>
                </div>
                <div className="boi-report-item border-bottom-left">
                  <img
                    src="assets/img/icons/check-square.svg"
                    alt="check-square"
                  />
                  <p>
                    You need to update information that has previously been
                    reported
                  </p>
                </div>
                <div className="boi-report-item border-bottom-right">
                  <img
                    src="assets/img/icons/check-square.svg"
                    alt="check-square"
                  />
                  <p>
                    You need to correct a mistake on a previously filed report
                  </p>
                </div>
                <div className="boi-report-item border-bottom-left">
                  <img
                    src="assets/img/icons/check-square.svg"
                    alt="check-square"
                  />
                  <p>
                    You company has recently become exempt from reporting
                    requirements
                  </p>
                </div>
                <div className="p-t-55 p-t-xs-40">
                  <Link to="https://boi.itump.com/login" className="theme-btn">
                    Get Started <i className="fa fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="boi-complete-section p-b-240 p-b-xl-200 p-b-lg-160 p-b-md-120 p-b-xs-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-6">
              <div className="common-title-wrap m-b-90 m-b-lg-70 m-b-md-50 m-b-xs-40">
                <h3
                  className="common-title mb-0"
                  data-aos="fade-up"
                  data-aos-delay="50"
                >
                  Complete your BOI Report in 3 easy steps
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="boi-complete-steps p-b-85 p-b-lg-60 p-b-md-50 p-b-xs-40">
                <div className="boi-complete-step">
                  <div
                    className="boi-step-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="57"
                      height="56"
                      viewBox="0 0 57 56"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.6666 4.6665H18.9999C10.8333 4.6665 7.33325 9.33317 7.33325 16.3332V39.6665C7.33325 46.6665 10.8333 51.3332 18.9999 51.3332H37.6666C45.8333 51.3332 49.3333 46.6665 49.3333 39.6665V16.3332C49.3333 9.33317 45.8333 4.6665 37.6666 4.6665ZM18.9999 28.5832H28.3333C29.2899 28.5832 30.0833 29.3765 30.0833 30.3332C30.0833 31.2898 29.2899 32.0832 28.3333 32.0832H18.9999C18.0433 32.0832 17.2499 31.2898 17.2499 30.3332C17.2499 29.3765 18.0433 28.5832 18.9999 28.5832ZM37.6666 41.4165H18.9999C18.0433 41.4165 17.2499 40.6232 17.2499 39.6665C17.2499 38.7098 18.0433 37.9165 18.9999 37.9165H37.6666C38.6233 37.9165 39.4166 38.7098 39.4166 39.6665C39.4166 40.6232 38.6233 41.4165 37.6666 41.4165ZM43.4999 21.5832H38.8333C35.2866 21.5832 32.4166 18.7132 32.4166 15.1665V10.4998C32.4166 9.54317 33.2099 8.74984 34.1666 8.74984C35.1233 8.74984 35.9166 9.54317 35.9166 10.4998V15.1665C35.9166 16.7765 37.2233 18.0832 38.8333 18.0832H43.4999C44.4566 18.0832 45.2499 18.8765 45.2499 19.8332C45.2499 20.7898 44.4566 21.5832 43.4999 21.5832Z"
                        fill="#7A7A7A"
                      />
                    </svg>
                  </div>
                  <div className="step-content">
                    <div
                      className="boi-complete-step-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <p>Information</p>
                    </div>
                    <div
                      className="boi-complete-step-info"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      <p>
                        You will need to provide certain relevant information,
                        includes company details, information regarding the
                        beneficial owners, and company applicant’s
                      </p>
                    </div>
                  </div>
                  <div className="step-shape">
                    <svg
                      width="321"
                      height="8"
                      viewBox="0 0 321 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M320.354 4.35355C320.549 4.15829 320.549 3.84171 320.354 3.64645L317.172 0.464466C316.976 0.269204 316.66 0.269204 316.464 0.464466C316.269 0.659728 316.269 0.976311 316.464 1.17157L319.293 4L316.464 6.82843C316.269 7.02369 316.269 7.34027 316.464 7.53553C316.66 7.7308 316.976 7.7308 317.172 7.53553L320.354 4.35355ZM0 4.5H2.96296V3.5H0V4.5ZM8.88889 4.5H14.8148V3.5H8.88889V4.5ZM20.7407 4.5H26.6667V3.5H20.7407V4.5ZM32.5926 4.5H38.5185V3.5H32.5926V4.5ZM44.4444 4.5H50.3704V3.5H44.4444V4.5ZM56.2963 4.5H62.2222V3.5H56.2963V4.5ZM68.1481 4.5H74.0741V3.5H68.1481V4.5ZM80 4.5H85.9259V3.5H80V4.5ZM91.8519 4.5H97.7778V3.5H91.8519V4.5ZM103.704 4.5H109.63V3.5H103.704V4.5ZM115.556 4.5H121.481V3.5H115.556V4.5ZM127.407 4.5H133.333V3.5H127.407V4.5ZM139.259 4.5H145.185V3.5H139.259V4.5ZM151.111 4.5H157.037V3.5H151.111V4.5ZM162.963 4.5H168.889V3.5H162.963V4.5ZM174.815 4.5H180.741V3.5H174.815V4.5ZM186.667 4.5H192.593V3.5H186.667V4.5ZM198.518 4.5H204.444V3.5H198.518V4.5ZM210.37 4.5H216.296V3.5H210.37V4.5ZM222.222 4.5H228.148V3.5H222.222V4.5ZM234.074 4.5H240V3.5H234.074V4.5ZM245.926 4.5H251.852V3.5H245.926V4.5ZM257.778 4.5H263.704V3.5H257.778V4.5ZM269.629 4.5H275.555V3.5H269.629V4.5ZM281.481 4.5H287.407V3.5H281.481V4.5ZM293.333 4.5H299.259V3.5H293.333V4.5ZM305.185 4.5H311.111V3.5H305.185V4.5ZM317.037 4.5H320V3.5H317.037V4.5Z"
                        fill="url(#paint0_linear_1955_2439)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1955_2439"
                          x1="0"
                          y1="4.5"
                          x2="320"
                          y2="4.5"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#323232" />
                          <stop offset="1" stop-color="#24305E" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
                <div className="boi-complete-step">
                  <div
                    className="boi-step-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="56"
                      height="56"
                      viewBox="0 0 56 56"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M32.4101 6.71984L21.4667 4.99317C12.3434 3.56984 8.12006 6.64984 6.67339 15.7732L4.94673 26.7165C4.01339 32.6898 4.99339 36.5632 8.37673 38.9198C10.1501 40.1798 12.5767 41.0198 15.7267 41.5098L26.6701 43.2365C35.7934 44.6598 40.0167 41.5798 41.4634 32.4565L43.1667 21.5132C43.4467 19.7165 43.5634 18.1065 43.4701 16.6832C43.1667 10.8498 39.7367 7.86317 32.4101 6.71984ZM19.2267 21.8165C16.4967 21.8165 14.2801 19.5998 14.2801 16.8932C14.2801 14.1632 16.4967 11.9465 19.2267 11.9465C21.9334 11.9465 24.1501 14.1632 24.1501 16.8932C24.1501 19.5998 21.9334 21.8165 19.2267 21.8165Z"
                        fill="#395ABF"
                      />
                      <path
                        d="M47.8334 31.4298L44.3334 41.9531C41.4167 50.7265 36.7501 53.0598 27.9767 50.1431L17.4534 46.6431C14.1634 45.5465 11.7834 44.1931 10.2434 42.4898C11.7134 43.0731 13.4167 43.5165 15.3534 43.8198L26.3201 45.5465C27.8134 45.7798 29.2134 45.8965 30.5201 45.8965C38.2201 45.8965 42.3501 41.7431 43.7734 32.8065L45.4767 21.8631C45.7101 20.5098 45.8034 19.3198 45.8034 18.2231C49.3501 21.1398 49.8634 25.2931 47.8334 31.4298Z"
                        fill="#395ABF"
                      />
                    </svg>
                  </div>
                  <div className="step-content">
                    <div
                      className="boi-complete-step-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <p>Questionnaire</p>
                    </div>
                    <div
                      className="boi-complete-step-info"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      <p>
                        Use the information you collected to complete the
                        questionnaire. We make this easy by guiding you each
                        step of the way
                      </p>
                    </div>
                  </div>
                  <div className="step-shape">
                    <svg
                      width="321"
                      height="8"
                      viewBox="0 0 321 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M320.354 4.35355C320.549 4.15829 320.549 3.84171 320.354 3.64645L317.172 0.464466C316.976 0.269204 316.66 0.269204 316.464 0.464466C316.269 0.659728 316.269 0.976311 316.464 1.17157L319.293 4L316.464 6.82843C316.269 7.02369 316.269 7.34027 316.464 7.53553C316.66 7.7308 316.976 7.7308 317.172 7.53553L320.354 4.35355ZM0 4.5H2.96296V3.5H0V4.5ZM8.88889 4.5H14.8148V3.5H8.88889V4.5ZM20.7407 4.5H26.6667V3.5H20.7407V4.5ZM32.5926 4.5H38.5185V3.5H32.5926V4.5ZM44.4444 4.5H50.3704V3.5H44.4444V4.5ZM56.2963 4.5H62.2222V3.5H56.2963V4.5ZM68.1481 4.5H74.0741V3.5H68.1481V4.5ZM80 4.5H85.9259V3.5H80V4.5ZM91.8519 4.5H97.7778V3.5H91.8519V4.5ZM103.704 4.5H109.63V3.5H103.704V4.5ZM115.556 4.5H121.481V3.5H115.556V4.5ZM127.407 4.5H133.333V3.5H127.407V4.5ZM139.259 4.5H145.185V3.5H139.259V4.5ZM151.111 4.5H157.037V3.5H151.111V4.5ZM162.963 4.5H168.889V3.5H162.963V4.5ZM174.815 4.5H180.741V3.5H174.815V4.5ZM186.667 4.5H192.593V3.5H186.667V4.5ZM198.518 4.5H204.444V3.5H198.518V4.5ZM210.37 4.5H216.296V3.5H210.37V4.5ZM222.222 4.5H228.148V3.5H222.222V4.5ZM234.074 4.5H240V3.5H234.074V4.5ZM245.926 4.5H251.852V3.5H245.926V4.5ZM257.778 4.5H263.704V3.5H257.778V4.5ZM269.629 4.5H275.555V3.5H269.629V4.5ZM281.481 4.5H287.407V3.5H281.481V4.5ZM293.333 4.5H299.259V3.5H293.333V4.5ZM305.185 4.5H311.111V3.5H305.185V4.5ZM317.037 4.5H320V3.5H317.037V4.5Z"
                        fill="url(#paint0_linear_1955_2440)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1955_2440"
                          x1="0"
                          y1="4.5"
                          x2="320"
                          y2="4.5"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#3451C4" stop-opacity="0.4" />
                          <stop offset="1" stop-color="#245BF2" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
                <div className="boi-complete-step">
                  <div
                    className="boi-step-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="57"
                      height="56"
                      viewBox="0 0 57 56"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M34.1501 4.6665H23.1834C20.7568 4.6665 18.7734 6.6265 18.7734 9.05317V11.2465C18.7734 13.6732 20.7334 15.6332 23.1601 15.6332H34.1501C36.5768 15.6332 38.5368 13.6732 38.5368 11.2465V9.05317C38.5601 6.6265 36.5768 4.6665 34.1501 4.6665Z"
                        fill="#245BF2"
                      />
                      <path
                        d="M40.8935 11.2466C40.8935 14.9566 37.8602 17.99 34.1502 17.99H23.1835C19.4735 17.99 16.4402 14.9566 16.4402 11.2466C16.4402 9.93995 15.0402 9.12329 13.8735 9.72995C10.5835 11.48 8.34351 14.9566 8.34351 18.9466V40.9033C8.34351 46.6433 13.0335 51.3333 18.7735 51.3333H38.5602C44.3002 51.3333 48.9902 46.6433 48.9902 40.9033V18.9466C48.9902 14.9566 46.7502 11.48 43.4602 9.72995C42.2935 9.12329 40.8935 9.93995 40.8935 11.2466ZM36.4602 29.7033L27.1268 39.0366C26.7768 39.3866 26.3335 39.55 25.8902 39.55C25.4468 39.55 25.0035 39.3866 24.6535 39.0366L21.1535 35.5366C20.4768 34.86 20.4768 33.74 21.1535 33.0633C21.8302 32.3866 22.9502 32.3866 23.6268 33.0633L25.8902 35.3266L33.9868 27.23C34.6635 26.5533 35.7835 26.5533 36.4602 27.23C37.1368 27.9066 37.1368 29.0266 36.4602 29.7033Z"
                        fill="#245BF2"
                      />
                    </svg>
                  </div>
                  <div className="step-content">
                    <div
                      className="boi-complete-step-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      <p>BOI Report</p>
                    </div>
                    <div
                      className="boi-complete-step-info"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      <p>
                        We contact FinCEN on your behalf and ensure that
                        everything is handled correctly while you monitor the
                        status of your application online
                      </p>
                    </div>
                  </div>
                  <div className="s-bio-shape-1">
                    <img src="assets/img/shape/shape-12.png" alt="shape" />
                  </div>
                </div>
              </div>
              <div
                className="text-center"
                data-aos="fade-up"
                data-aos-delay="50"
              >
                <Link to="https://boi.itump.com/login" className="theme-btn">
                  Get Started <i className="fa fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="industry-solution">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 ">
              <div className="common-title-wrap m-b-70 m-b-md-50 m-b-xs-40">
                <h3
                  className="common-title"
                  data-aos="fade-up"
                  data-aos-delay="50"
                >
                  Why File with Us
                </h3>
                <p
                  className="common-title-body"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  Let Us Handle Your FinCEN BOI Reporting
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="industry-solution-wrap file-with-us-wrap">
                <div className="industry-solution-item w-100">
                  <div
                    className="solution-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="49"
                      height="48"
                      viewBox="0 0 49 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.3335 4C13.2935 4 4.3335 12.96 4.3335 24C4.3335 35.04 13.2935 44 24.3335 44C35.3735 44 44.3335 35.04 44.3335 24C44.3335 12.96 35.3735 4 24.3335 4ZM32.6335 25.66L29.1735 26.82C28.2135 27.14 27.4735 27.88 27.1535 28.84L25.9935 32.3C25.0135 35.28 20.8135 35.22 19.8935 32.24L15.9935 19.68C15.2335 17.18 17.5335 14.88 19.9935 15.64L32.5735 19.54C35.5535 20.48 35.5935 24.68 32.6335 25.66Z"
                        fill="#7256FF"
                      />
                    </svg>
                  </div>
                  <div className="solution-content">
                    <p
                      className="solution-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      Ease of Use
                    </p>
                    <p
                      className="solution-body"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      Quick and easy to submit all necessary information for
                      fast processing.
                    </p>
                  </div>
                </div>
                <div className="industry-solution-item w-100">
                  <div
                    className="solution-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M32 4H16C9 4 6 8 6 14V34C6 40 9 44 16 44H32C39 44 42 40 42 34V14C42 8 39 4 32 4ZM16 24.5H24C24.82 24.5 25.5 25.18 25.5 26C25.5 26.82 24.82 27.5 24 27.5H16C15.18 27.5 14.5 26.82 14.5 26C14.5 25.18 15.18 24.5 16 24.5ZM32 35.5H16C15.18 35.5 14.5 34.82 14.5 34C14.5 33.18 15.18 32.5 16 32.5H32C32.82 32.5 33.5 33.18 33.5 34C33.5 34.82 32.82 35.5 32 35.5ZM37 18.5H33C29.96 18.5 27.5 16.04 27.5 13V9C27.5 8.18 28.18 7.5 29 7.5C29.82 7.5 30.5 8.18 30.5 9V13C30.5 14.38 31.62 15.5 33 15.5H37C37.82 15.5 38.5 16.18 38.5 17C38.5 17.82 37.82 18.5 37 18.5Z"
                        fill="#7256FF"
                      />
                    </svg>
                  </div>
                  <div className="solution-content">
                    <p
                      className="solution-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      Compliance Assurance
                    </p>
                    <p
                      className="solution-body"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      Ensure compliance with expert guidance and accurate
                      filings to avoid fines and penalties.
                    </p>
                  </div>
                </div>
                <div className="industry-solution-item w-100">
                  <div
                    className="solution-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="49"
                      height="48"
                      viewBox="0 0 49 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.6667 4C13.6467 4 4.66675 12.98 4.66675 24C4.66675 35.02 13.6467 44 24.6667 44C35.6867 44 44.6667 35.02 44.6667 24C44.6667 12.98 35.6867 4 24.6667 4ZM33.3667 31.14C33.0867 31.62 32.5867 31.88 32.0667 31.88C31.8067 31.88 31.5467 31.82 31.3067 31.66L25.1067 27.96C23.5667 27.04 22.4267 25.02 22.4267 23.24V15.04C22.4267 14.22 23.1067 13.54 23.9267 13.54C24.7467 13.54 25.4267 14.22 25.4267 15.04V23.24C25.4267 23.96 26.0267 25.02 26.6467 25.38L32.8467 29.08C33.5667 29.5 33.8067 30.42 33.3667 31.14Z"
                        fill="#7256FF"
                      />
                    </svg>
                  </div>
                  <div className="solution-content">
                    <p
                      className="solution-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      Time Savings
                    </p>
                    <p
                      className="solution-body"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      Focus on running your business rather than dealing with
                      complex reporting requirements.
                    </p>
                  </div>
                </div>
                <div className="industry-solution-item w-100">
                  <div
                    className="solution-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="49"
                      height="48"
                      viewBox="0 0 49 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M37.4134 8.24018L26.4133 4.12018C25.2733 3.70018 23.4133 3.70018 22.2733 4.12018L11.2733 8.24018C9.15335 9.04018 7.43335 11.5202 7.43335 13.7802V29.9802C7.43335 31.6002 8.49335 33.7402 9.79335 34.7002L20.7933 42.9202C22.7333 44.3802 25.9133 44.3802 27.8533 42.9202L38.8533 34.7002C40.1533 33.7202 41.2134 31.6002 41.2134 29.9802V13.7802C41.2334 11.5202 39.5134 9.04018 37.4134 8.24018ZM31.2933 19.4402L22.6933 28.0402C22.3933 28.3402 22.0133 28.4802 21.6333 28.4802C21.2533 28.4802 20.8733 28.3402 20.5733 28.0402L17.3734 24.8002C16.7934 24.2202 16.7934 23.2602 17.3734 22.6802C17.9534 22.1002 18.9133 22.1002 19.4933 22.6802L21.6533 24.8402L29.1933 17.3002C29.7733 16.7202 30.7333 16.7202 31.3133 17.3002C31.8933 17.8802 31.8933 18.8602 31.2933 19.4402Z"
                        fill="#7256FF"
                      />
                    </svg>
                  </div>
                  <div className="solution-content">
                    <p
                      className="solution-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      Secure Data Handling
                    </p>
                    <p
                      className="solution-body"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      Protect your sensitive information, ensure your data is
                      handled safely and confidentially.
                    </p>
                  </div>
                </div>
                <div className="industry-solution-item w-100 border-b-none">
                  <div
                    className="solution-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="48"
                      height="48"
                      viewBox="0 0 48 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.8577 30.5176L20.8475 30.4936C20.6405 30.4447 20.4348 30.391 20.2303 30.3325L20.2149 30.3273C18.2594 29.7652 16.4535 28.775 14.928 27.4285C13.2504 25.9486 11.9603 24.0807 11.1702 21.9878C10.38 19.8949 10.1139 17.6405 10.3949 15.4211C10.6759 13.2018 11.4956 11.0848 12.7825 9.25494C14.0694 7.42504 15.7843 5.93772 17.7779 4.92267C19.7714 3.90763 21.983 3.39567 24.2198 3.43144C26.4566 3.46721 28.6507 4.04962 30.6108 5.1279C32.5709 6.20617 34.2374 7.74756 35.4651 9.61767C36.6928 11.4878 37.4444 13.6298 37.6543 15.8571C37.7212 16.5651 37.14 17.1428 36.4286 17.1428C35.7189 17.1428 35.1515 16.5651 35.0692 15.8588C34.8426 13.9101 34.1055 12.0558 32.9325 10.4834C31.7595 8.91092 30.1921 7.67601 28.3889 6.90348C26.5856 6.13095 24.6103 5.84819 22.6628 6.08378C20.7152 6.31938 18.8643 7.06497 17.2973 8.2452C15.7302 9.42543 14.5025 10.9984 13.7383 12.8053C12.9741 14.6121 12.7004 16.5886 12.945 18.5351C13.1895 20.4816 13.9436 22.329 15.1311 23.8906C16.3185 25.4522 17.8972 26.6726 19.7075 27.4285L19.776 27.4576C20.1189 27.5982 20.4709 27.7222 20.832 27.8296C21.1355 27.0964 21.6838 26.4912 22.3836 26.1171C23.0833 25.743 23.8912 25.6232 24.6694 25.7781C25.4476 25.933 26.148 26.3531 26.6512 26.9666C27.1543 27.5802 27.4291 28.3493 27.4286 29.1428C27.4294 29.9307 27.1587 30.6949 26.6621 31.3067C26.1656 31.9185 25.4735 32.3406 24.7022 32.502C23.931 32.6634 23.1277 32.5541 22.4275 32.1927C21.7273 31.8313 21.173 31.2398 20.8577 30.5176ZM19.1675 32.6982C16.1221 31.7511 13.4219 29.9306 11.4017 27.4628C10.1498 27.6094 8.99536 28.2107 8.15757 29.1525C7.31978 30.0942 6.85702 31.3109 6.85718 32.5713V33.7971C6.85718 40.1708 14.0743 44.5713 24 44.5713C33.9257 44.5713 41.1429 39.9291 41.1429 33.7971V32.5713C41.1429 31.2074 40.6011 29.8993 39.6366 28.9348C38.6721 27.9703 37.364 27.4285 36 27.4285H29.7515C30.1558 28.7828 30.0691 30.2364 29.5066 31.5331C28.944 32.8297 27.9418 33.8862 26.6765 34.5161C25.4112 35.1461 23.9642 35.3092 22.5904 34.9766C21.2167 34.644 20.0045 33.8371 19.1675 32.6982ZM32.5715 17.1428C32.5715 14.5508 31.4229 12.2279 29.604 10.6559C28.6914 9.86865 27.6231 9.2827 26.4687 8.93631C25.3142 8.58992 24.0998 8.49088 22.9045 8.64566C21.7092 8.80044 20.56 9.20555 19.5319 9.83455C18.5038 10.4636 17.6199 11.3023 16.938 12.296C16.256 13.2898 15.7912 14.4162 15.5741 15.6017C15.3569 16.7873 15.3922 18.0052 15.6777 19.1762C15.9631 20.3472 16.4923 21.4448 17.2307 22.3973C17.9691 23.3499 18.9001 24.1361 19.9629 24.7045C21.0674 23.6997 22.5069 23.1429 24 23.1428C25.4938 23.1424 26.9339 23.6993 28.0389 24.7045C29.4085 23.9728 30.5536 22.8829 31.3519 21.551C32.1502 20.2192 32.5717 18.6955 32.5715 17.1428Z"
                        fill="#7256FF"
                      />
                    </svg>
                  </div>
                  <div className="solution-content">
                    <p
                      className="solution-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      Expert Support
                    </p>
                    <p
                      className="solution-body"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      Gain quick access to our knowledgeable, dedicated support
                      team.
                    </p>
                  </div>
                </div>
                <div className="industry-solution-item w-100 border-r-none border-b-none">
                  <div
                    className="solution-icon"
                    data-aos="zoom-in"
                    data-aos-delay="50"
                  >
                    <svg
                      width="49"
                      height="48"
                      viewBox="0 0 49 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M39.9268 14.4798C40.5268 15.4198 40.2068 16.6798 39.2468 17.2598L38.0668 17.9598L11.8468 33.6798C10.8868 34.2598 9.62682 33.9398 9.06682 32.9598C7.06682 29.4798 6.16682 25.2398 6.94682 20.7998C8.26682 13.2598 14.4668 7.25981 22.0468 6.17981C29.5468 5.11981 36.3268 8.71981 39.9268 14.4798Z"
                        fill="#7256FF"
                      />
                      <path
                        d="M42.4468 26.8601C41.0868 35.3601 33.5668 41.8601 24.9468 42.0001C21.1468 42.0601 17.6268 40.9601 14.7068 38.9801C13.4668 38.1601 13.5068 36.3201 14.7868 35.5601L39.6068 20.9801C40.9068 20.2201 42.5068 21.1001 42.6268 22.6001C42.7268 24.0001 42.6668 25.4201 42.4468 26.8601Z"
                        fill="#7256FF"
                      />
                    </svg>
                  </div>
                  <div className="solution-content">
                    <p
                      className="solution-title"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      Comprehensive Recording
                    </p>
                    <p
                      className="solution-body"
                      data-aos="fade-up"
                      data-aos-delay="150"
                    >
                      Keep organized, accessible records on Itump for easier
                      compliance and audit management.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-12">
              <div
                className="text-center m-t-65 m-t-md-50 m-t-xs-40"
                data-aos="fade-up"
                data-aos-delay="50"
              >
                <Link to="https://boi.itump.com/login" className="theme-btn">
                  Get Started <i className="fa fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* testimonial section start  */}
      <section className="testimonial-section p-t-230 p-t-xl-200 p-t-lg-160 p-t-md-120 p-t-xs-120 p-b-255 p-b-xl-200 p-b-lg-160 p-b-md-120 p-b-xs-120 overflow-hidden position-relative">
        <div className="container">
          <div className="testimonial-section-wrapper d-flex align-items-lg-center flex-column flex-lg-row">
            <div className="common-title-wrap position-relative z-1">
              <h2
                className="common-title m-b-5"
                data-aos="fade-up"
                data-aos-delay="50"
              >
                What our users have to say
              </h2>
              <div
                className="slider-btn-wrapper d-flex align-items-center"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                <button
                  type="button"
                  title="slide prev"
                  className="slider-btn t-slider-btn-prev d-flex align-items-center justify-content-center rounded-circle border-0"
                >
                  <i className="fa fa-arrow-left-long"></i>
                </button>
                <button
                  type="button"
                  title="slide next"
                  className="slider-btn t-slider-btn-next d-flex align-items-center justify-content-center rounded-circle border-0"
                >
                  <i className="fa fa-arrow-right-long"></i>
                </button>
              </div>
              <img
                src="assets/img/shape/testimonial-area-shape.png"
                alt="shape"
                className="border-shape position-absolute d-none d-lg-block"
                data-aos="zoom-in"
                data-aos-delay="50"
              />
            </div>
            <div
              className="testimonial-slider-container flex-shrink-0 position-relative"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <div className="testimonial-slider swiper">
                <div className="testimonial-slider-wrapper swiper-wrapper">
                  <div className="testimonial-item-cotnainer swiper-slide">
                    <div className="testimonial-item">
                      <img
                        src="assets/img/icons/quote-left.svg"
                        alt="quote-left"
                        className="qoute-icon mb-3"
                      />
                      <p className="testimonial-desc">
                        itump FinCen's BOI has been a game changer, With Itump's
                        seamless BOI reporting service, I was able to complete
                        my ownership reporting effortlessly. The platform guided
                        me through each step, ensuring that I provided all
                        necessary details accurately and on time
                      </p>
                      <div className="user-info d-flex flex-column gap-1">
                        <div className="user-img rounded-circle">
                          <img
                            src="assets/img/user-avatar.png"
                            alt="user img"
                            className="w-100 h-100 object-fit-cover rounded-circle"
                          />
                        </div>
                        <h5 className="user-name fw-bold mb-0">
                          Alex Thompson
                        </h5>
                        <span className="user-designation">
                          CEO of Innovative Solutions Inc.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-item-cotnainer swiper-slide">
                    <div className="testimonial-item">
                      <img
                        src="assets/img/icons/quote-left.svg"
                        alt="quote-left"
                        className="qoute-icon mb-3"
                      />
                      <p className="testimonial-desc">
                        itump FinCen's BOI has been a game changer, With Itump's
                        seamless BOI reporting service, I was able to complete
                        my ownership reporting effortlessly. The platform guided
                        me through each step, ensuring that I provided all
                        necessary details accurately and on time
                      </p>
                      <div className="user-info d-flex flex-column gap-1">
                        <div className="user-img rounded-circle">
                          <img
                            src="assets/img/user-avatar.png"
                            alt="user img"
                            className="w-100 h-100 object-fit-cover rounded-circle"
                          />
                        </div>
                        <h5 className="user-name fw-bold mb-0">
                          Alex Thompson
                        </h5>
                        <span className="user-designation">
                          CEO of Innovative Solutions Inc.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* testimonial section end */}

      <FAQSection faqs={faqs} />

      <ServiceSliderSection />

      <section className="itump-mobile-section p-b-275 p-b-xl-220 p-b-lg-180 p-b-md-120 p-b-xs-80 position-relative overflow-hidden">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <ItumpMobile />
            </div>
            <div className="col-md-6" data-aos="fade-up" data-aos-delay="50">
              <div className="contact-info">
                <div className="contact-icon">
                  <img src="assets/img/icons/location-dot.svg" alt="location" />
                </div>
                <p>
                  30 Wall Street, <br /> New York, NY 10005
                </p>
              </div>
            </div>
            <div className="col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="contact-info">
                <div className="contact-icon d-flex align-items-center">
                  <img src="assets/img/icons/phone.svg" alt="phone" />
                  <img src="assets/img/icons/envelope2.svg" alt="envelope" />
                </div>
                <div className="contact-link">
                  <Link to="/tel:(888) 87-ITUMP">(888) 87-ITUMP</Link>
                  <Link
                    className="text-decoration-underline"
                    to="/start.today@itump.com"
                  >
                    start.today@itump.com
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src="assets/img/thumb/thumb-38.png"
          alt="pattern"
          className="bg-pattern w-100 mx-auto start-0 end-0 bottom-0 position-absolute d-none d-md-block"
        />
      </section>

      <FooterSection />

      <CopyrightSection />
    </>
  );
};

export default Service;
